import { combineEpics } from 'redux-observable';
import { updateCollaboratorEpic } from './update-collaborator';
import { createCollaboratorEpic } from './create-collaborator';
import { getCollaboratorsEpic } from './get-collaborators';
import { removeCollaboratorEpic } from './remove-collaborator';
import { autosaveEpic } from './autosave';
import { getCollaboratorsForTrackEpic } from './get-collaborators-for-track';
import { createCollaboratorsAfterEdition } from './create-collaborators-after-edition';
import { updateCollaboratorOrderEpic } from './update-collaborator-order';
import { createCollaboratorsAfterInvite } from './create-collaborators-after-invite';
import { getCollaboratorsAfterCreateOwnershipEpic } from './get-collaborators-after-create-ownership';
import { createArtistCollaboratorEpic } from './create-artist-collaborator';
import { createCollaboratorForOtherTracksEpic } from './create-collaborator-for-other-tracks';
import { createCollaboratorForSongwriter } from './create-collaborator-for-songwriter';
import { createCreditForFeaturedArtistEpic } from './create-credit-for-featured-artists';
import { createLyricistCreditForSongsEpic } from './create-lyricist-credit-for-songs';

const collaboratorEpic = combineEpics(
  autosaveEpic,
  getCollaboratorsEpic,
  getCollaboratorsForTrackEpic,
  createCollaboratorEpic,
  createArtistCollaboratorEpic,
  updateCollaboratorEpic,
  removeCollaboratorEpic,
  createCollaboratorsAfterEdition,
  createCollaboratorsAfterInvite,
  updateCollaboratorOrderEpic,
  getCollaboratorsAfterCreateOwnershipEpic,
  createCollaboratorForOtherTracksEpic,
  createCreditForFeaturedArtistEpic,
  createCollaboratorForSongwriter,
  createLyricistCreditForSongsEpic
);

export default collaboratorEpic;
